<template>
  <div class="login_bg">
    <div class="content">
      <el-card>
        <el-form
          :model="ruleForm"
          status-icon
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="用户名" prop="username">
            <el-input v-model="ruleForm.username"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input
              type="password"
              v-model="ruleForm.password"
              autocomplete="off"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
            <el-button @click="resetForm('ruleForm')">重置</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    var checkUser = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入用户"));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        callback();
      }
    };

    return {
      ruleForm: {
        password: "",

        username: "",
      },
      rules: {
        password: [{ validator: validatePass, trigger: "blur" }],

        username: [{ validator: checkUser, trigger: "blur" }],
      },
    };
  },
  methods: {
    ...mapActions({
      setLoginDataAction: "setLoginDataAction",
    }),
    login() {
      this.setLoginDataAction({
        username: this.ruleForm.username,
        password: this.ruleForm.password,
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.login();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
  computed: {
    //   ...mapState({dataIndex:"index.dataIndex"}),
    ...mapState({
      result: (state) => state.login.result,
    }),
  },
  watch: {
    result(newdata, olddata) {
      if (newdata.code == 404 || newdata.code == 400) {
        this.$message({
          message: "登陆失败",
          type: "warning",
        });
      }
      if(newdata.code==405){

          this.$message({
              message: "账户已被禁用",

          });
      }
      if (newdata.code == 200) {
        this.$message({
          message: "恭喜你，登陆成功",
          type: "success",
        });
        setTimeout(() => {
          this.$router.push({
            name: "index",
          });
        }, 500);
      }
      console.log(newdata, olddata);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.login_bg {
  background: url("../../assets/login-bg.jpg") no-repeat center top;
  background-size: cover;
  height: 100vh;
}
.content {
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  height: 40%;
  width: 40%;
  margin: auto;
}
</style>
